import MainChart from './MainChart';

export default MainChart;